import RestoreFromTrashRoundedIcon from "@material-ui/icons/RestoreFromTrashRounded";
import { getAllBrands, deleteAndRestoreBrand } from "../../reduxSaga/actions";
import { useSelector, useDispatch } from "react-redux";
import AddBrand from "../../ui/AddBrand";
import { useEffect, useState } from "react";
import EditBrand from "../../ui/EditBrand";
import { useNavigate } from "react-router-dom";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";
import CashRegisterService from "../../services/ProductSellBToC/CashRegisterService";
import UtilsFormule from "../../utils/UtilsFormule";
import AddCaisse from "../../ui/AddCaisse";
const CashRegister = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [oldBrandData, setOldBrandData] = useState();
  const [availableCashRegister, setAvailableCashRegister] = useState([]);
  const [onAddCashRegister, setOnAddCashRegister] = useState(false);
  const [userRole, setUserRole] = useState("");

  useEffect(() => {
    if (localStorage.getItem("status") == null) {
      setUserRole(["notConnected"]);
    } else {
      setUserRole(JSON.parse(localStorage.getItem("status")));
    }
    CashRegisterService.getAllCashRegister(getCurrentUserId())
      .then((response) => {
        if (response.data.success) {
          setAvailableCashRegister(response.data.success);
        } else {
          console.log("error in getAllCashRegister", response.data.success);
        }
      })
      .catch((e) => {
        console.log("error in getAllCashRegister", e);
      });
  }, []);

  const onAddCashRegisterHandler = () => {
    setOnAddCashRegister(true);
  };

  const onArchiveHandler = (brandId, archiveOrRestored) => {
    let deletedAndRestoreModel = {
      idBrand: brandId,
      isDeleted: archiveOrRestored,
    };

    dispatch(deleteAndRestoreBrand(deletedAndRestoreModel));
  };

  const onViewProductsHandler = (brandId, brandName) => {
    sessionStorage.setItem("typePage", "brand");
    sessionStorage.setItem("idBrand", brandId);
    navigate(`/getListProductsInfo`);
  };

  const onVoirTicketsCaisses = (id) => {
    localStorage.setItem("idDetailsTicketCaisse", id);
    window.open("/ticket-caisse", "_blank");
  };
  const onVoirJournauxCaisses = (id) => {
    localStorage.setItem("idCaisse", id);
    localStorage.setItem("typeGetJournaux", "caisse");
    window.open("/journal-caisse", "_blank");
  };
  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <div className="content ">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">
              <div class="card  mt-3">
                <div class="card-body">
                  <h5 class="card-title">Les Caisses</h5>

                  <button
                    class="btn btn-dark float-right"
                    data-toggle="modal"
                    data-target="#add-brand"
                    onClick={onAddCashRegisterHandler}
                  >
                    <i class="fas fa-plus"></i>
                  </button>
                </div>
              </div>
              <section class="content">
                <div class="card">
                  <div class="card-header  ">
                    <h3 class="card-title">Les caisses</h3>
                    <div class="card-tools">
                      <button
                        type="button"
                        class="btn btn-tool"
                        data-card-widget="collapse"
                        title="Collapse"
                      >
                        <i class="fas fa-minus"></i>
                      </button>
                    </div>
                  </div>
                  <div class="card-body p-0">
                    <table class="table  projects">
                      <thead>
                        <tr>
                          <th>Libellé</th>
                          <th style={{ width: "12%" }}>DC</th>
                          {/* <th className="text-center" style={{ width: "12%" }}>
                            Modifier
                          </th>
                          <th className="text-center" style={{ width: "12%" }}>
                            Voir Plus
                          </th> */}
                          <th className="text-center" style={{ width: "12%" }}>
                            Les Tickets
                          </th>{" "}
                          {userRole.includes("ADMIN") && (
                            <th
                              className="text-center"
                              style={{ width: "12%" }}
                            >
                              Les journaux
                            </th>
                          )}
                          <th className="text-center" style={{ width: "12%" }}>
                            Archiver
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {availableCashRegister &&
                          availableCashRegister.map((element, i) => (
                            <tr key={element.id}>
                              <td>{element.reference}</td>

                              <td>
                                {UtilsFormule.formatDate(element.creationDate)}
                              </td>

                              {/* <td className="text-center">
                                <button
                                  style={{ width: 40 }}
                                  class="btn bg-gray btn-sm "
                                  data-toggle="modal"
                                  data-target="#edit-brand"
                                  // onClick={() =>
                                  //   // onEditBrandHandler(
                                  //   //   element.id,
                                  //   //   element.name,
                                  //   //   element.description
                                  //   // )
                                  // }
                                >
                                  <i class="fas fa-pencil-alt"></i>
                                </button>
                              </td> */}

                              {/* <td className="text-center">
                                <button
                                  style={{ width: 40 }}
                                  class="btn bg-black btn-sm "
                                  onClick={() =>
                                    onViewProductsHandler(
                                      element.id,
                                      element.name
                                    )
                                  }
                                >
                                  <i class="fas fa-shopping-cart"></i>
                                </button>
                              </td> */}
                              <td className="text-center">
                                <button
                                  style={{ width: 40 }}
                                  class="btn btn-dark btn-sm"
                                  onClick={() =>
                                    onVoirTicketsCaisses(element.id)
                                  }
                                >
                                  <i class="fas fa-ticket"></i>
                                </button>
                              </td>
                              {userRole.includes("ADMIN") && (
                                <td className="text-center">
                                  <button
                                    style={{ width: 40 }}
                                    class="btn btn-dark btn-sm"
                                    onClick={() =>
                                      onVoirJournauxCaisses(element.id)
                                    }
                                  >
                                    <i class="fas fa-book"></i>
                                  </button>
                                </td>
                              )}
                              <td className="text-center">
                                <button
                                  style={{ width: 40 }}
                                  class="btn btn-danger btn-sm"
                                  onClick={() =>
                                    onArchiveHandler(element.id, 1)
                                  }
                                >
                                  <i class="fas fa-trash"></i>
                                </button>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
      {onAddCashRegister && (
        <AddCaisse setOnAddCashRegister={setOnAddCashRegister} />
      )}
    </div>
  );
};
export default CashRegister;
